import appConfig from '@/utils/appConfig'

export const featureAccess = (featureName) => {
    return appConfig[`VUE_APP_FEATURE_${featureName}`]
}

export const isExceptionStatus = (status) => {
    const exceptionsStatusesList = [501]

    return exceptionsStatusesList.find(item => item === status)
}

export const findRoleIdsByPermissionNames = (data, permissionNames) => {
  const result = [];

  for (const role of data) {
    const hasPermission = role.permissions.some(permission =>
      permissionNames.includes(permission.name)
    );

    if (hasPermission) {
      result.push(role._id);
    }
  }

  return result;
}

export const checkingAccessToTheEntity = (permissions, resource = 'entity', requiredOperations = ['get']) => {
  if (!appConfig.VUE_APP_FEATURE_FEATURES_ACCESS) return true

  const foundOperations = new Set();

  for (const perm of permissions) {
    if (perm.resource === resource && Array.isArray(perm.operation)) {
      for (const op of perm.operation) {
        if (requiredOperations.includes(op)) {
          foundOperations.add(op);
        }
      }
    }
  }

  return requiredOperations.every(op => foundOperations.has(op));
}

export const checkPermissions = (permissions, required = []) => {
  if (!appConfig.VUE_APP_FEATURE_FEATURES_ACCESS) return true
  if (!permissions) return false

  const available = new Set(permissions.map(p => p.name))

  return required.every(permName => available.has(permName))
}


export const checkingAccessToResource = (permissions, resources, operations) => {
  const resourceMap = {};

  if (typeof resources === 'string') {
    resourceMap[resources] = Array.isArray(operations) ? operations : [operations];
  } else if (typeof resources === 'object' && resources !== null) {
    Object.assign(resourceMap, resources);
  } else {
    return false;
  }

  const found = {};

  for (const resource in resourceMap) {
    found[resource] = new Set();
  }

  for (const perm of permissions) {
    const { resource, operation } = perm;

    if (
      resource in resourceMap &&
      Array.isArray(operation)
    ) {
      for (const op of operation) {
        if (resourceMap[resource].includes(op)) {
          found[resource].add(op);
        }
      }
    }
  }

  return Object.entries(resourceMap).every(([resource, requiredOps]) =>
    requiredOps.every(op => found[resource].has(op))
  );
};

export function getPublicState(routeQuery) {
  return Boolean(appConfig.VUE_APP_FEATURE_PUBLIC_CASES && routeQuery?.caseId && routeQuery?.public)
}
